import { AdVertical } from "./AdVerticals";

export const AD_TYPES = [
  "lease",
  "sale",
  "stallion-at-stud",
  "agistment",
  "wanted",
  "service",
] as const;

export type AdType = (typeof AD_TYPES)[number];

export interface AdTypeOption {
  label: string;
  value: AdType;
}

export const HORSE_AD_TYPES = [
  "sale",
  "lease",
  "wanted",
  "stallion-at-stud",
] as const;

export const VEHICLE_AD_TYPES = ["sale", "lease", "wanted"] as const;

export const SADDLERY_AND_MORE_AD_TYPES = ["sale", "lease", "wanted"] as const;

export const PROPERTY_AD_TYPES = [
  "sale",
  "lease",
  "wanted",
  "agistment",
  "service",
] as const;

export const AD_TYPES_BY_VERTICAL: Record<AdVertical, readonly AdType[]> = {
  horse: HORSE_AD_TYPES,
  vehicle: VEHICLE_AD_TYPES,
  "saddlery-and-more": SADDLERY_AND_MORE_AD_TYPES,
  property: PROPERTY_AD_TYPES,
};

export type AdHorseSaleType = (typeof HORSE_AD_TYPES)[number];

export const AD_TYPE_OPTIONS: AdTypeOption[] = [
  {
    label: "For Sale",
    value: "sale",
  },
  {
    label: "For Lease",
    value: "lease",
  },
  {
    label: "Want to Buy",
    value: "wanted",
  },
  {
    label: "Stallion at Stud",
    value: "stallion-at-stud",
  },
  {
    label: "Agistment",
    value: "agistment",
  },
  {
    label: "Service",
    value: "service",
  },
];
